"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniversalLinks = exports.getDefaultUniversalLinks = void 0;
const basic_types_1 = require("../constants/generated/basic-types");
const get_domain_1 = require("./get-domain");
const get_market_1 = require("./get-market");
const getDefaultUniversalLinks = (brand, country) => {
    var _a;
    const hostname = (_a = (0, get_domain_1.getDomain)(brand, country)) !== null && _a !== void 0 ? _a : 'rbi.tools';
    const tld = hostname.substring(hostname.indexOf('.') + 1);
    const stageUniversalLinks = Object.values(basic_types_1.Stage)
        .filter((stage) => stage !== basic_types_1.Stage.None)
        .flatMap((stage) => [
        `${stage}-${brand.toLowerCase()}-web.${tld}.rbi.tools`,
        `${stage}-${brand.toLowerCase()}-${country.toLowerCase()}-web.rbi.tools`,
    ]);
    // By default we want open web links in app when installed
    const defaultUniversalLinks = [hostname, `www.${hostname}`, ...stageUniversalLinks];
    return defaultUniversalLinks.map((link) => ({ link, provider: 'rbi' }));
};
exports.getDefaultUniversalLinks = getDefaultUniversalLinks;
const getAdditionalUniversalLinks = (brand, iso2) => {
    const market = (0, get_market_1.getMarket)(brand, iso2);
    return market === null || market === void 0 ? void 0 : market.additionalUniversalLinks;
};
const getUniversalLinks = (brand, country) => {
    return [
        ...(0, exports.getDefaultUniversalLinks)(brand, country),
        ...(getAdditionalUniversalLinks(brand, country) || []),
    ];
};
exports.getUniversalLinks = getUniversalLinks;
